import { render, staticRenderFns } from "./PaginateTable.vue?vue&type=template&id=72aef0e4&scoped=true&"
import script from "./PaginateTable.vue?vue&type=script&lang=js&"
export * from "./PaginateTable.vue?vue&type=script&lang=js&"
import style0 from "./PaginateTable.vue?vue&type=style&index=0&id=72aef0e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aef0e4",
  null
  
)

export default component.exports